<template>
  <div class="toaster">
  <div ref="toaster">
  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';
import Toast from './Toast.vue';

export default {
  name: 'toaster',
  props: {
  },
  data(){
    return {
      dynamicComponent:'toast',
      children:[],
      toastId:0,
    }
  },
  components:{
  },
  computed:mapState([
    'count'
    ]),
  methods:{
    toast(message){
      this.vueInstance= new Vue({
      render: h => h( Toast,{
        props:{
          message:this.$t(message),
        },
        on:{
          removeToast:child => {
            this.$refs['toaster'].removeChild(child.$el);
            child.$destroy();
          },
        },
      })
    }).$mount();

      this.$refs['toaster'].appendChild(this.vueInstance.$el);

    }
  },
  created(){
    // create global instance on Vue
    Vue.$toaster=this;
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.toaster{
  position:fixed;
  bottom:0;
  left:0;
  width:100%;
  z-index:100000;
}
</style>
